import IRepository from "./repository";

const GETTER_GET_FORM = 'getForm';
const GETTER_GET_CONSUMER = 'getConsumer';
const GETTER_GET_ACCOUNT = 'getAccount';
const GETTER_GET_CODE = 'getCode';
const GETTER_GET_ACCOUNT_SETTING = 'getAccountSetting';
const GETTER_GET_REPLY = 'getReply';
const GETTER_GET_REPLIED_AT = 'getRepliedAt';
const GETTER_GET_SESSION_KEY = 'getSessionKey';
const GETTER_GET_SESSION_TOKEN = 'getSessionToken';
const GETTER_GET_APPOINTMENT = 'getAppointment';
const GETTER_GET_CONTACT_DETAILS = 'getContactDetails';

const ACTION_LOAD_FORM_BY_LINK = 'loadFormByLink';
const ACTION_LOAD_FORM_BY_CODE = 'loadFormByCode';
const ACTION_LOAD_REPLY = 'loadReply';
const ACTION_LOAD_FOR_PREVIEW ='loadForPreview';

export default class FormsRepository extends IRepository {

    getContactDetails() {
        return this.getters(GETTER_GET_CONTACT_DETAILS);
    }

    getSessionKey() {
        return this.getters(GETTER_GET_SESSION_KEY);
    }

    getSessionToken() {
        return this.getters(GETTER_GET_SESSION_TOKEN);
    }

    getReply() {
        return this.getters(GETTER_GET_REPLY);
    }

    getReply() {
        return this.getters(GETTER_GET_REPLY);
    }

    getConsumer() {
        return this.getters(GETTER_GET_CONSUMER);
    }

    getForm() {
        return this.getters(GETTER_GET_FORM);
    }

    getAccount() {
        return this.getters(GETTER_GET_ACCOUNT);
    }

    getCode() {
        return this.getters(GETTER_GET_CODE);
    }

    getRepliedAt() {
        return this.getters(GETTER_GET_REPLIED_AT);
    }

    getAccountSetting() {
        return this.getters(GETTER_GET_ACCOUNT_SETTING);
    }

    getAppointment() {
        return this.getters(GETTER_GET_APPOINTMENT);
    }

    loadFormByLink(linkHash, request, consumer) {
        return this.dispatch(ACTION_LOAD_FORM_BY_LINK, {linkHash, request, consumer});
    }

    loadFormByCode(code) {
        return this.dispatch(ACTION_LOAD_FORM_BY_CODE, code);
    }

    loadReply(replyId) {
        return this.dispatch(ACTION_LOAD_REPLY, replyId)
    }

    loadForPreview(formId) {
        return this.dispatch(ACTION_LOAD_FOR_PREVIEW, formId)
    }
}